export default "__VITE_ASSET__uqE1jYiI__"